import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectProcessContext } from '../../../state/instance-detail/selector'

export default createUIDefinition({
    taskName: taskName.MATCH_3SHAPE,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
    ],
    overwriteWidget: true,
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        const threeShapeCaseId = context.threeShapeCaseId
        const messageList = []

        if (eventName === 'done' && !threeShapeCaseId) {
            messageList.push(createValidationMessage('Please select a case', 'validateThreeShapeCase'))
        }

        if (eventName === 'not_scanned' && threeShapeCaseId) {
            messageList.push(createValidationMessage('Please deselect the case', 'validateThreeShapeCase'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/match-3shape.js